'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Bind;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Bind(functionOrArray, context) {
    function bind(method, _context) {
        if (typeof method === 'function') {
            _jquery2.default.proxy(method, _context);
        }
    }

    if (Array.isArray(functionOrArray)) {
        functionOrArray.forEach(function (item) {
            bind(item, context);
        });
    } else {
        bind(functionOrArray, context);
    }
} //  weak
//# sourceMappingURL=Bind.js.map